// Demo page: NextAdmin / (home) dashboard (DashboardPage: a chart card above a grid of cards), matched in light and dark.
import { useMemo, useState } from 'react';
import { ChartCard } from '../../components/charts/index.js';
import { DashboardGrid, DashboardPage } from '../../components/page/index.js';
import { PAGE_HELP } from '../../help/index.js';
import { DetailPanel, SummaryCard } from './EntityCards.js';
import { EntityMap } from './EntityMap.js';
import { ENTITIES } from './entity-summaries-data.js';

export function EntitySummariesPage() {
  const [activeId, setActiveId] = useState(ENTITIES[0].id);
  const activeEntity = useMemo(() => ENTITIES.find((entity) => entity.id === activeId) ?? ENTITIES[0], [activeId]);

  return (
    <DashboardPage
      title="Entity summaries"
      helpContent={PAGE_HELP['entity-summaries']}
      subtitle="Boundaries, ownership and routing rules for the core product entities."
    >
      <ChartCard
        title="How the entities connect"
        description="Project, then ProjectThread, ProjectChange and Workstream. Hover or focus a box for its summary."
      >
        <EntityMap />
      </ChartCard>

      <DashboardGrid className="sm:grid-cols-2 xl:grid-cols-4">
        {ENTITIES.map((entity) => (
          <SummaryCard
            key={entity.id}
            entity={entity}
            active={entity.id === activeId}
            onSelect={() => setActiveId(entity.id)}
          />
        ))}
      </DashboardGrid>

      <DetailPanel entity={activeEntity} />
    </DashboardPage>
  );
}
